import React from 'react';

import { EnvelopeIcon, LockClosedIcon } from '@heroicons/react/24/outline';

import Input from '../Input';
import { EMAIL, LoginInputProps, PASSWORD } from './types';

export type { LoginInputProps, LoginInputType } from './types';

const placeholderMap: Record<string, string> = {
  [EMAIL]: 'Enter your email',
  [PASSWORD]: 'Enter your password',
};

const iconMap: Record<string, React.ReactNode> = {
  [EMAIL]: <EnvelopeIcon className="text-grey-400 h-20 w-20" />,
  [PASSWORD]: <LockClosedIcon className="text-grey-400 h-20 w-20" />,
};

const LoginInput: React.FC<LoginInputProps> = ({ loginType, type, placeholder, ...inputProps }) => {
  const getIcon = () => {
    return iconMap[loginType];
  };

  const getPlaceholder = () => {
    if (placeholder) return placeholder;
    return placeholderMap[loginType];
  };

  // Auto-set input type based on loginType if not explicitly provided
  const getInputType = () => {
    if (type) return type; // Use explicit type if provided
    return loginType === PASSWORD ? 'password' : 'email';
  };

  return (
    <Input
      {...inputProps}
      type={getInputType()}
      placeholder={getPlaceholder()}
      icon={getIcon()}
      iconPosition="left"
      className="ring-none rounded-full bg-slate-300 shadow-none"
    />
  );
};

export default LoginInput;
